/** A silent request is handled by Login, even when the central session is active. */
export const shouldShowActiveSessionPage = (isAuthenticated: boolean, prompt: string | null): boolean =>
  isAuthenticated && prompt !== "none";
